import * as svg from "../../../assets/alert-circle-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const AlertCircleIcon = iconBuilder(svg, "AlertCircleIcon", "0 0 16 16");
